import { defaultTheme } from 'sletat-ui-components2/dist/theme';

const imageLoaderStyles = {
    '& .uikit-loader': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#e1e1e1',
        borderRadius: 2,
        height: '100%',
        paddingRight: 12,

        '&__spinner > div': {
            backgroundColor: '#999'
        }
    },

    '& .uikit-image-with-loader': {
        height: '100%'
    },

    '& .uikit-image-with-loader__img': {
        width: 'auto',
        minWidth: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: defaultTheme.theme.borderRadiusVariables.main,
    }
};

const zoomButtonMain = {
    content: '""',
    position: 'absolute',
    top: 10,
    right: 10,
    height: 20,
    width: 20,
    backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjMjMyMTIxIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjcyODIgMy4yNDYzMlYySDE3Ljk5OThWNy4yNzE1OEgxNi43NTM1VjQuMTM4OTVMMTIuMjU2NiA4LjYxODk1TDExLjM4MDkgNy43NDMxNkwxNS44NjA5IDMuMjQ2MzJIMTIuNzI4MlpNMy4yNDYzMiAxNS44NjEzTDcuNzQzMTYgMTEuMzgxM0w4LjYxODk1IDEyLjI1NzFMNC4xMzg5NSAxNi43NTRINy4yNzE1OFYxOC4wMDAzSDJWMTIuNzI4N0gzLjI0NjMyVjE1Ljg2MTNaTTE2Ljc1MzUgMTUuODYxM0wxMi4yNTY2IDExLjM4MTNMMTEuMzgwOSAxMi4yNTcxTDE1Ljg2MDkgMTYuNzU0SDEyLjcyODJWMTguMDAwM0gxNy45OTk4VjEyLjcyODdIMTYuNzUzNVYxNS44NjEzWk03LjI3MTU4IDJWMy4yNDYzMkg0LjEzODk1TDguNjE4OTUgNy43NDMxNkw3Ljc0MzE2IDguNjE4OTVMMy4yNDYzMiA0LjEzODk1VjcuMjcxNThIMlYySDcuMjcxNThaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K")'
};

export const styles = {
    main: {
        position: 'relative',
        display: 'flex',
        padding: 0,
        height: 465
    },
    left: {
        marginRight: 10,
        width: '67%'
    },
    right: {
        width: '32%'
    },
    hotelLabels: {
        position: 'absolute',
        top: 8,
        left: 20,
        padding: [4, 8],
        borderRadius: 2,
        color: '#8b572a',
        fontSize: 12,
        backgroundColor: '#fff9b1',
        zIndex: 1
    },
    largePhotoWrap: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden',
        cursor: 'pointer',
        borderRadius: defaultTheme.theme.borderRadiusVariables.main,

        ...imageLoaderStyles,

        '&::after': {
            ...zoomButtonMain
        }
    },
    rightItem: {
        display: 'flex',
        position: 'relative',
        height: 227,
        width: '100%',
        overflow: 'hidden',
        flexWrap: 'wrap',
        justifyContent: 'space-between',

        ...imageLoaderStyles,

        '&:first-child': {
            marginBottom: 11
        },
    },
    zoomable: {
        position: 'relative',
        width: '100%',
        cursor: 'pointer',

        '&::after': {
            display: 'none',

            ...zoomButtonMain
        },

        '&:hover::after': {
            display: 'block'
        }
    },
    blackout: {
        position: 'absolute',
        display: 'flex',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(25, 25, 29, 0.6)',
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: defaultTheme.theme.borderRadiusVariables.main,
    },
    morePhotos: {
        height: 20,
        color: '#fff',
        fontSize: 14,
        borderBottom: '1px dashed #FFFFFF'
    },
    smallPhoto: {
        position: 'relative',
        height: 110,
        width: '49%',
        overflow: 'hidden',
        cursor: 'pointer',

        '&:first-child': {
            marginBottom: 7
        }
    },
    star: {
        color: '#ffca00'
    }
};

export type ComponentJSSClasses = typeof styles;
